import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import AuthApi from '../../api/auth/AuthApi'
import { LoginDto } from '../../api/auth/types'
import { logIn } from '../../redux/storageToolkit'
import store from '../../redux/store'
import { HttpError } from '../../types/common'
import { showErrorToast } from '../../utils/errors'
import { isAuthError } from '../../services/errors/utils'
import { AuthSubcodes } from '../../services/errors/consts'

const authApi = AuthApi.getInstance()

export function useLogin(onError: (error: AxiosError<HttpError>, variables: LoginDto) => void) {
  const texts = useTranslation().t
  const navigate = useNavigate()

  const mutation = useMutation(async (body: LoginDto) => {
    const { data } = await authApi.login(body)
    return data
  }, {
    onSuccess: (data) => {
      store.dispatch(logIn(data))
      navigate('/')
    },
    onError: (error: AxiosError<HttpError>, variables: LoginDto) => {
      if (!isAuthError(error, AuthSubcodes.EMAIL_NOT_VERIFIED)) {
        showErrorToast(error, texts)
      } else {
        onError(error, variables)
      }
    }
  })
  return mutation
}